import { Injectable, Injector } from '@angular/core';
import { ApiService } from "../api.service";

@Injectable()
export class PerformanceService {

	constructor(private apiService: ApiService) {}

	getConfigByName(configName) {
		return this.apiService.loadConfig("./assets/config/performance/" + configName + ".json");
	}
	getAllSceneList(){
		return this.getConfigByName("sceneList");
	}

	/*保存情景模拟的答题 */
	saveExercisesAnswers(exerciseId,data){
		return this.apiService.ajax({
			'type': 'post',
			'data':data,
			'url': '/sr/maxSimulation/saveExercisesAnswers'
		});
	}

	// 保存情景模拟第一题的答题
  saveFirstChoiceAnswers(exerciciseId,data){
	  return this.apiService.ajax({
      'type':'post',
      'data':data,
      'url':'/sr/maxSimulation/saveFirstChoiceAnswers'
    })
  }


	/*保存进度 */
	saveProgress(exerciseId,data){
		return this.apiService.ajax({
			'type': 'post',
			'data':data,
			'url': '/sr/maxSimulation/saveProgress/' + exerciseId
		});
	}
	/*重做情景模拟 */
	reset(exerciseId){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/maxSimulation/reset/' + exerciseId
		});
	}
	/* 获取驱动变革情景模拟第一个选择题内容 */
	getFirstChoiceInfo(exerciseId){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/maxSimulation/getFirstChoiceInfo/' + exerciseId
		});
	}
	/* 获取当前步骤 */
	getProgress(exerciseId){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/maxSimulation/getProgress/' + exerciseId
		});
	}


	/* 获取选择题后动画 */
	getQuestionAnswerAnimate(optionList) {
		let animateList = [{
			"begin": [{
					"el": '<div id="revolution_step3_0" class="result"><div class="container">'+ this.getQuestionAnswerContent(optionList) +'</div></div>'
				}
			],
			"end": [{
					"el": "#revolution_step3_0",
					"className": "fadeOut"
				}
			]
		}];
		return animateList;
	}
	/* 获取选择题后动画 */
	getQuestionAnswerAnimate2(optionList) {
		let animateList = [{
			"begin": [{
					"el": '<div id=\"revolutionall-person2\"><div id=\"talkBox2\" class=\"talkBox2\"><div id=\"talkBoxContent2\" class=\"fontSize16\">'+ this.getQuestionAnswerContent2(optionList) +'</div><div id=\"talkBoxName2\" class=\"fontSize16 talkBoxName2\">魏宇</div></div></div>'
				}
			],
			"end": [{
					"el": "#revolutionall-person2",
					"className": "fadeOut"
				}
			]
		}];
		return animateList;
	}
	/* 获取选择题后内容 */
	getQuestionAnswerContent(optionList){
		let answerContent = "<ul>";
		optionList.forEach((item,index)=>{
			if(item.selected){
				answerContent += "<li>"+ item.description +"</li>";
			}
		});
		answerContent += "</ul>"
		return answerContent;
	}
	getQuestionAnswerContent2(optionList){
		let answerContent = "";
		optionList.forEach((item,index)=>{
			if(item.selected){
				answerContent += item.description;
			}
		});
		return answerContent;
	}
	/* 获取用户驱动变革情景模拟决策树  */
	getExercises(exerciseId,step){
		return this.apiService.ajax({
			'type': 'get',
        'url': '/sr/maxSimulation/exercises/' + exerciseId +'/'+ step
		});
	}
	/* 获取用户驱动变革情景模拟决策树(历史回顾)  */
	getExercisesHis(exerciseId,step){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/maxSimulation/exercisesHis/' + exerciseId +'/'+ step
		});
	}

	/* 完成驱动变革情景模拟  */
	finishExercises(exerciseId){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/maxSimulation/finish/' + exerciseId
		});
	}

	/* 获取当前阶段的导师反馈  */
	getTutorFeedback(exerciseId,step){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/maxSimulation/getTutorFeedback/' + exerciseId +'/'+ step
		});
	}

	/* 获取用户驱动变革能力下的情景模拟列表  */
	getPracticeList(learningPathId,practiceMetaId){
		return this.apiService.ajax({
			'type': 'get',
			'url': '/sr/maxSimulation/createAndGet/' + learningPathId +'/'+ practiceMetaId
		});
	}

	setSavePoint(exerciseId,data){
	  return this.apiService.ajax({
      'type':'post',
      'data':data,
      'url':'/sr/maxSimulation/saveMaxSceneReview'
    })
  }

  getSavePoint(exerciseId){
    return this.apiService.ajax({
      'type': 'get',
      'url': '/sr/maxSimulation/getMaxSceneReview/' + exerciseId
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-performance/performanceService.ts